
  import { defineComponent } from 'vue';
  import './paragraph.scss';
  /**
   * Paragraphs are usually represented in visual media as blocks of text separated from adjacent blocks by blank lines and/or first-line indentation
   * 
   * @example
   * <code>import TpxParagraph from '@manifesto-tech/tpximpact-design-system/components/atoms/type/paragraph.vue'</code>
   */
  export default defineComponent({
    name: 'TpxParagraph',
    
    props: {
      /**
       * Content to be displayed within the paragraph
       */
      content: {
        type: String,
      },
    },
  });
